<era-security-list-user-items-ui [users]="memberUsers$ | async"
                                 [isEditing]="isEditing()"
                                 (deleteEvent)="delete($event)"></era-security-list-user-items-ui>